import React, { useState } from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { LessonForm } from './LessonForm';

const TAG = { ganada: 'bg-emerald-500/15 text-emerald-300', perdida: 'bg-rose-500/15 text-rose-300', manual: 'bg-amber-500/15 text-amber-300', feedback: 'bg-sky-500/15 text-sky-300' };
const LABEL = { ganada: 'Causa ganada', perdida: 'Causa perdida', manual: 'Escrita a mano', feedback: 'Evaluación' };

export const LessonCard = ({ item, kind, onSave, onDelete }) => {
  const [editing, setEditing] = useState(false);
  const tag = kind === 'feedback' ? 'feedback' : item.outcome;
  const tid = `fidem-memory-${kind}-${item.id}`;
  const save = async (body) => { if (await onSave(kind, item.id, body)) setEditing(false); };
  return (
    <div data-testid={tid} className="rounded-xl border border-slate-800 bg-slate-900/60 p-4 transition-colors hover:border-slate-700">
      <div className="mb-2 flex flex-wrap items-center gap-2 text-xs">
        <span className={`rounded-full px-2 py-0.5 ${TAG[tag] || TAG.manual}`}>{LABEL[tag] || tag}</span>
        <span className="font-medium text-slate-200">{kind === 'feedback' ? (item.question || 'Respuesta de Fidem') : (item.materia || item.title || 'Sin materia')}</span>
        <span className="text-slate-500">· {item.owner}{item.title && kind === 'lesson' ? ` · ${item.title}` : ''}</span>
        <div className="ml-auto flex gap-1">
          <button data-testid={`${tid}-edit`} onClick={() => setEditing(!editing)} className="rounded p-1.5 text-slate-400 hover:bg-slate-800 hover:text-amber-300"><Pencil className="h-3.5 w-3.5" /></button>
          <button data-testid={`${tid}-delete`} onClick={() => onDelete(kind, item.id)} className="rounded p-1.5 text-slate-400 hover:bg-slate-800 hover:text-rose-300"><Trash2 className="h-3.5 w-3.5" /></button>
        </div>
      </div>
      {editing ? <LessonForm testid={`${tid}-form`} initial={item} noteOnly={kind === 'feedback'} onSave={save} onCancel={() => setEditing(false)} />
        : kind === 'feedback' ? <p className="text-sm text-slate-300">«{item.note}»</p>
        : <ul className="list-disc space-y-1 pl-5 text-sm text-slate-300">{item.lecciones.map((l, i) => <li key={i}>{l}</li>)}</ul>}
    </div>
  );
};
